import React, { Component } from 'react';
import './SitePlan.css';
import PlotMoreInformationType from '../enums/PlotMoreInformationType';
import BirdsEyeView from './BirdsEyeView';
import Filters from './Filters';
import AvailablePricesFilter from './AvailablePricesFilter';
import Favourite from '../favourites/Favourite';
import StatusFilter from './StatusFilter';
import BedroomsFilter from './BedroomsFilter';
import FeaturesFilter from './FeaturesFilter';
import MenuBar from './MenuBar';
import MainMenu from './MainMenu';
import VideoPlayer from './VideoPlayer';
import MenuManager from './MenuManager';
import HouseTypeFilter from './HouseTypeFilter';
import PlotFilterer from '../filters/PlotFilterer';
import PlotSearch from './PlotSearch';
import SitePicker from './SitePicker';
import Spinner from './Spinner';
import Specification from './Specification';
import MouseBlocker from './MouseBlocker';
import Handles from '../core/Handles';
import PlotMoreInformation from './PlotMoreInformation';
import BrochureGeneration from './BrochureGeneration';
import ImageViewer from './ImageViewer';
import Favourites from './Favourites';
import Dialog from './Dialog';
import AssetsManager from '../assets_management/AssetsManager';
import StylesHelper from '../html/StylesHelper';
import PrivacyPolicy from './PrivacyPolicy';
import SitePlan3D from './SitePlan3D';
import SitePlan360 from './SitePlan360';
import Configurator from './Configurator';
import LocalArea from './LocalArea';
import Urls from '../urls/Urls';
import SitePlanVisibleType from '../enums/SitePlanVisibleType';
import PlotMenu from './PlotMenu';
import UrlHelper from '../core/UrlHelper';
import ParameterErrors from '../errors/ParameterErrors';
import BrochuresMenu from '../brochures/BrochuresMenu';
import BrochuresManager from '../brochures/BrochuresManager';
import PlotDetailedInformationsManager from '../plot_detailed_information/PlotDetailedInformationsManager';
import PlotComparisonManager from '../plot_detailed_information/PlotComparisonManager';
import PlotsSelectionMenu from './PlotsSelectionMenu';
import HouseTypesViewer from '../house_types_viewer/HouseTypesViewer';
import HouseGridSelector from '../house_types_viewer/HouseGridSelector';
import UrlParameters from '../urls/UrlParameters';
import HouseTypesViewModel from '../view_models/HouseTypesViewModel';
import PlotStatus from '../site/PlotStatus';
import FullScreenImagesViewer from './FullScreenImagesViewer';
import EmGalleryFullScreenImagesViewer from './EmGalleryFullScreenImagesViewer';
import NearbySites from './NearbySites';
import Tutorials from '../tutorials/Tutorials';
import SiteSpecific from '../site_specific/current/SiteSpecific';
import E from '../ui_core/E';
import GoogleAnalytics from '../google/GoogleAnalytics';
import SalesForceWelcomePage from './SalesForceWelcomePage';
const urlParams = new URLSearchParams(window.location.search);
const hashType = window.location.href.split('#')[1];
const{throwNotProvided}=ParameterErrors;
export default class SitePlan extends Component {
	static get BIRDS_EYE_VIEW_ZOOM_MIN(){
		return 1;
	}
	static get BIRDS_EYE_VIEW_ZOOM_MAX(){
		return 6;
	}
	static get _MAX_FAVOURITES(){
		return 10
	}
	constructor(props){
		super(props);
		const {configuration, callbackDidMount}=props;
		window.configuration = configuration;
		if(configuration.helpTutorialEnabled){
			Tutorials.showing = true;
		}
		this._callbackDidMount = callbackDidMount;
		this._getConfiguration = ()=>configuration;
		this._elementRef = React.createRef();
		this._menuBarRef=React.createRef();
		this._mainMenuRef = React.createRef();
		this._filtersRef=React.createRef();
		this._availablePricesFilterRef = React.createRef(); 
		this._statusFilterRef = React.createRef();
		this._bedroomsFilterRef = React.createRef();
		this._plotSearchRef = React.createRef();
		this._houseTypeFilterRef = React.createRef();
		this._featuresFilterRef = React.createRef();
		this._spinnerRef = React.createRef();
		this._mouseBlockerRef=React.createRef();
		this._plotMoreInformationRef=React.createRef();
		this._brochureGenerationRef = React.createRef();
		this._favouritesRef = React.createRef();
		this._imageViewerRef=React.createRef();
		this._showForSale=this._showForSale.bind(this);
		this.initialize = this.initialize.bind(this);
		this._birdsEyeViewRef=React.createRef();
		this._privacyPolicyRef= React.createRef();
		this._sitePlan3DRef = React.createRef();
		this._sitePlan360Ref = React.createRef();
		this._localAreaRef = React.createRef();
		this._specificationRef = React.createRef();
		this._configuratorRef = React.createRef();
		this._menuManagerRef = React.createRef();
		this._plotMenuRef = React.createRef();
		this._brochuresMenuRef = React.createRef();
		this._spinnerHandles = new Handles();
		this._loadSite= this._loadSite.bind(this);
		this._load3dSite= this._load3dSite.bind(this);
		this._getFilteredPlots = this._getFilteredPlots.bind(this);
		this._handleShowMainMenu = this._handleShowMainMenu.bind(this);
		this._filtersChanged=this._filtersChanged.bind(this);
		this._filterAndLoadPlots=this._filterAndLoadPlots.bind(this);
		this._loadIndividualPlot = this._loadIndividualPlot.bind(this);
		this._clearFilters = this._clearFilters.bind(this);
		this._plotSearchSelectedPlot=this._plotSearchSelectedPlot.bind(this);
		this._getDimensions = this._getDimensions.bind(this);
		this._handleShowPlotMoreInformation = this._handleShowPlotMoreInformation.bind(this);
		this._handlePlaySiteVideo = this._handlePlaySiteVideo.bind(this);
		this._handleShowTwoDSitePlan = this._handleShowTwoDSitePlan.bind(this);
		this._handleClickedFavourite = this._handleClickedFavourite.bind(this);
		this._handleZoomChange = this._handleZoomChange.bind(this);
		this._handleShowLocalArea= this._handleShowLocalArea.bind(this);
		this._handleShowSpecification = this._handleShowSpecification.bind(this);
		this.resize= this.resize.bind(this);
		this._setMenuBarZoom= this._setMenuBarZoom.bind(this);
		this._handleSetFavouritesActive= this._handleSetFavouritesActive.bind(this);
		this._handleFavouritesHide= this._handleFavouritesHide.bind(this);
		this._handleExpandImage=this._handleExpandImage.bind(this);
		this._handleAddFavourite = this._handleAddFavourite.bind(this);
		this._handleRemoveFavourite = this._handleRemoveFavourite.bind(this);
		this._handleShowHouseGridSelector = this._handleShowHouseGridSelector.bind(this);
		this._handleShowOutside360 = this._handleShowOutside360.bind(this);
		this._handleShowDefaultOutside360 = this._handleShowDefaultOutside360.bind(this);
		this._handleShow3d = this._handleShow3d.bind(this);
		this._handleShowBrochures = this._handleShowBrochures.bind(this);
		this._handleBackFromSitePlan360 = this._handleBackFromSitePlan360.bind(this);
		this._handleEnterHouse = this._handleEnterHouse.bind(this);
		this._handleShowSuggestedSites = this._handleShowSuggestedSites.bind(this);
		this._initializeConfiguredCssClasses = this._initializeConfiguredCssClasses.bind(this);
		this._showTooManyFavouritesDialog = this._showTooManyFavouritesDialog.bind(this);
		this._handlePreviousSitePlanVisibleTypeElseDefault = this._handlePreviousSitePlanVisibleTypeElseDefault.bind(this);
		this._handleHideLocalArea = this._handleHideLocalArea.bind(this);
		this._handleHideSpecification = this._handleHideSpecification.bind(this);
		this._handleShowBrochureGenerationDialog= this._handleShowBrochureGenerationDialog.bind(this);
		this._handleShowSendFavouritesBrochure= this._handleShowSendFavouritesBrochure.bind(this);
		this._handleShowStreetView= this._handleShowStreetView.bind(this);
		this._hasSpaceToShowMenuOnOpen= this._hasSpaceToShowMenuOnOpen.bind(this);
		this._menuBarIsHorizontalChanged = this._menuBarIsHorizontalChanged.bind(this);
		this._handleEnterHouseByPlotNumber = this._handleEnterHouseByPlotNumber.bind(this);
		this._setupFirstShowPlotMarkers = this._setupFirstShowPlotMarkers.bind(this);
		this._showPlotDetailedInformation = this._showPlotDetailedInformation.bind(this);
		this._showImagesFullScreen = this._showImagesFullScreen.bind(this);
		this._handleShowPlots = this._handleShowPlots.bind(this);
		this._handleShowHouseTypes = this._handleShowHouseTypes.bind(this);
		this._showPlotMenuForPlot = this._showPlotMenuForPlot.bind(this);
		this._hidePlotMenu = this._hidePlotMenu.bind(this);
		this.setFilterInSiteFromWhatAreYouLookingFor = this.setFilterInSiteFromWhatAreYouLookingFor.bind(this);
		this._showPrivacyPolicy = this._showPrivacyPolicy.bind(this);
		this._previousSitePlanVisibleType = null;
		this._currentSitePlanVisibleType = null;
		this._plotFilterer = new PlotFilterer();
		this._siteJson = null;
		this._initializedConfiguredCssClasses = null;
		this._showPlotMarkers = false;
		this._doneFirstShowPlotMarkers=false;
		this.state = {birdsEyeView:null, menuBarHorizontal:false, fadeInPlotMarkers:true}
	}
	initialize({siteJsons}){
		return new Promise((resolve, reject)=>{
			const spinnerHandle = this._spinnerHandles.take();
			this._loadSite(siteJsons).then(()=>{	
				spinnerHandle.dispose()
				resolve(this);
			}).catch((err)=>{
				spinnerHandle.dispose();
				reject(err);
			});
		});
	}
	_loadSite(siteJsons){
		return new Promise((resolve, reject)=>{
			AssetsManager.getSiteAssets(this._getConfiguration()).then(({siteJson, configuration})=>{
				this._siteJson = siteJson;
				this._houseTypesViewModel = new HouseTypesViewModel(this._siteJson.getPlotsArray());
				const unitsArray = siteJson.units.getArray();
				const plotsArray = siteJson.units.getPlotsArray();
				this._initializeConfiguredCssClasses(configuration.plotStatusConfigurations);
				this._plotFilterer.clearFilters();
				this._availablePricesFilterRef.current.load({plotsArray:plotsArray, availablePricesSettings:this._siteJson.filtersSettings.availablePricesSettings,
					currencyConfiguration:this._siteJson.currencyConfiguration});
					this._featuresFilterRef.current.load({siteJson});
				this._statusFilterRef.current.load(plotsArray);
				this._houseTypeFilterRef.current.load(this._houseTypesViewModel, siteJson);
				this._bedroomsFilterRef.current.load(plotsArray);
				this._plotSearchRef.current.load(siteJson.units);
				this._plotsSelectionMenu?.initialize({siteJson});
				this._houseTypesViewer?.initialize({siteJson, 
					houseTypesViewModel:this._houseTypesViewModel});
				this._houseGridSelector?.initialize({siteJson, 
					houseTypesViewModel:this._houseTypesViewModel});
				if(siteJsons)
					this._nearbySites?.initialize({siteJsons, thisSiteJson:siteJson});
				this._filtersRef.current.load({siteJson});
				if(UrlParameters.salesforce){
					this._emGalleryFullScreenImagesViewer = new EmGalleryFullScreenImagesViewer();
					this._elementRef.current.appendChild(this._emGalleryFullScreenImagesViewer.element);
					if(!UrlParameters.noWelcomePage){
						this._salesForceWelcomePage = new SalesForceWelcomePage({showHouseGrid:this._handleShowHouseGridSelector, configuration});
						document.body.appendChild(this._salesForceWelcomePage.element);
						const buttonShowSalesForceWelcomePage= E.button('button-show-sales-force-welcome-page');
						let cancelled;
						
						const clearGoToWelcomePageTimeout=()=>{
							if(this._currentTimeoutGoToWelcomeScreenIfInactive){
								clearTimeout(this._currentTimeoutGoToWelcomeScreenIfInactive);
								this._currentTimeoutGoToWelcomeScreenIfInactive = null;
							}
						};
						let nClicksShortSpaceTime = 0;
						const goToWelcomePage = ()=>{			
							nClicksShortSpaceTime = 0;
							clearGoToWelcomePageTimeout();
							this._favouritesRef.current?.clear();
							this._salesForceWelcomePage.show();
						};
						buttonShowSalesForceWelcomePage.addEventListener('mousedown', ()=>{
							nClicksShortSpaceTime++;
							if(nClicksShortSpaceTime>=4)
								goToWelcomePage();
							else
								setTimeout(()=>{
									if(nClicksShortSpaceTime>0)
										nClicksShortSpaceTime--
								}, 4000);
						});
						document.body.appendChild(buttonShowSalesForceWelcomePage);
						const prepareToGoToWelcomeScreenIfInactive = ()=>{
							clearGoToWelcomePageTimeout();
							this._currentTimeoutGoToWelcomeScreenIfInactive = setTimeout(()=>{
								goToWelcomePage();
							}, 10*60000);
						};
						document.body.addEventListener('click', prepareToGoToWelcomeScreenIfInactive);
						prepareToGoToWelcomeScreenIfInactive();
					}
				}
				this._filterAndLoadPlots().then(()=>{
					this._sitePlan360Ref.current.load(siteJson, this._getConfiguration()).then(()=>{//needs to be visible as loads.
							this._setVisibleType(SitePlanVisibleType.BIRDS_EYE_VIEW);
							if(this._hasSpaceToShowMenuOnOpen()){
								this._handleShowMainMenu();//simpligon 
								if(AssetsManager.configuration.playSiteVideoOnOpen)
									setTimeout(()=>this._handlePlaySiteVideo(), 0);
							}
							this._setupFirstShowPlotMarkers();
						resolve();
					}).catch(reject);
				}).catch(reject);
			}).catch(reject);
		});
	}
	_initializeThreeDIfEnabled({configuration, siteJson}){
		return new Promise((resolve, reject)=>{
			if(!configuration.threeDEnabled)return Promise.resolve();
			this._sitePlan3DRef.current.load(siteJson).then(resolve).catch(reject);
		});
	}
	setFilterInSiteFromWhatAreYouLookingFor(whatAreYouLookingForViewModel){
		whatAreYouLookingForViewModel.visible = false;
		const plotsStillAvailableWithAnd = whatAreYouLookingForViewModel.getPlotsStillAvailableForSite(this._siteJson);
		if(plotsStillAvailableWithAnd.length>0){
			this._plotFilterer.clearFilters();
			this._statusFilterRef.current.setAvailableOnly();
			this._houseTypeFilterRef.current.setFromWhatAreYouLookingForViewModel(whatAreYouLookingForViewModel);
			this._bedroomsFilterRef.current.setFromWhatAreYouLookingForViewModel(whatAreYouLookingForViewModel);
			this._availablePricesFilterRef.current.setFromWhatAreYouLookingForViewModel(whatAreYouLookingForViewModel);
			const filteredPlots = this._getFilteredPlots();
			if(filteredPlots.length>0){
				this._plotsSelectionMenu?.setFilteredPlots(filteredPlots);
				this._plotMenuRef.current.setFilteredPlots(filteredPlots);
				return;
			}
		}
		
		const loadPlotsDirectory = (plots, message)=>{	
			this._doneFirstShowPlotMarkers=true;		
			const siteJsonUnits = [];
			plots.forEach(plot=>{
				if(siteJsonUnits.indexOf(plot.unit)<0)
					siteJsonUnits.push(plot.unit);
			});
			this._birdsEyeViewRef.current.load({siteJson:this._siteJson, unitsArray:siteJsonUnits,
				showPlotMarkers:true, filtered:false})
			.catch(console.error);
			this._plotsSelectionMenu?.setFilteredPlots(plots);
			this._plotMenuRef.current.setFilteredPlots(plots);
			/*
			this._currentDialog = Dialog.create({
				title:'Info', 
				className:'brochure-generation-result-dialog error',
				message:message,
				options:[{text:'OK', callback:()=>{
					
				}}]}
			);*/
		};
		
		const plotsStillAvailableWithOr = whatAreYouLookingForViewModel.getPlotsStillAvailableWithOr(this._siteJson);
		if(plotsStillAvailableWithOr.length>0)
		{
			loadPlotsDirectory(plotsStillAvailableWithOr, 
				'No plots matched all filters. The active plots matched some of the filters!');
			return;
		}
		
		const allPlots = this._siteJson.getPlotsArray();
		const allAvailablePlotsForSite = allPlots.filter(siteJsonUnitPlot=>siteJsonUnitPlot.status===PlotStatus.AVAILABLE);
		if(allAvailablePlotsForSite.length>0){
			loadPlotsDirectory(allAvailablePlotsForSite, 
				'No available plots currently match what you’re looking for, please see other available plots below');
			return;
		}
		
		const allPlotsThatCouldBecomeAvailable = allPlots.filter(siteJsonUnitPlot=>siteJsonUnitPlot.status!==PlotStatus.SOLD_OR_UNAVAILABLE&&siteJsonUnitPlot.status!==PlotStatus.RESERVED);
		if(allPlotsThatCouldBecomeAvailable.length>0){
			loadPlotsDirectory(allPlotsThatCouldBecomeAvailable,
				'The site had no available plots. Please see other plots which may become available');
			return;
		}
		
		loadPlotsDirectory(allPlots, 'The site had no available plots. Showing other plots.');
		
	}
	resize(){
		this._birdsEyeViewRef.current?.resize();
	}
	_load3dSite(){
		return new Promise((resolve, reject)=>{
			AssetsManager.getSiteAssets(this._getConfiguration()).then(({siteJson, configuration})=>{
				this._sitePlan3DRef.current.load(siteJson).then(()=>{
					resolve();
				}).catch(reject);
			}).catch(reject);
		});
	}
	_setupFirstShowPlotMarkers(){
		const delayShowPlotMarkersSeconds = this._getConfiguration().delayShowPlotMarkersSeconds;
		const show = ()=>{
			if(this._doneFirstShowPlotMarkers)return;
			this._doneFirstShowPlotMarkers = true;
			this._showPlotMarkers= true;
			this._filterAndLoadPlots().then(()=>{
				setTimeout(()=>{
					this.setState({fadeInPlotMarkers:false});
				}, 5000);
			}).catch(console.error);
		};
		if(delayShowPlotMarkersSeconds>0){
			setTimeout(show,delayShowPlotMarkersSeconds*1000);
		}
		else
			show();
		const handleFirstMouseDown = ()=>{
			document.documentElement.removeEventListener('mousedown', handleFirstMouseDown);
			show();
		};
		document.documentElement.addEventListener('mousedown', handleFirstMouseDown);
	}
	_setVisibleType(sitePlanVisibleType, noPlotMenu){
		return new Promise((resolve, reject)=>{
			this._previousSitePlanVisibleType = this._currentSitePlanVisibleType;
			if(this._previousSitePlanVisibleType)
				document.body.classList.remove(SitePlanVisibleType.getCssClassName(this._previousSitePlanVisibleType));
			switch(sitePlanVisibleType){
				case SitePlanVisibleType.BIRDS_EYE_VIEW:
					this._birdsEyeViewRef.current.setVisible(true);
					this._sitePlan360Ref.current.setVisible(false);
					this._sitePlan3DRef.current.setVisible(false);
					this._configuratorRef.current.setVisible(false);
					if(!noPlotMenu)
						this._plotMenuRef?.current?.showIfIsLoaded();
					this._localAreaRef?.current?.setVisible(false);
					this._specificationRef?.current?.setVisible(false);
				break;
				case SitePlanVisibleType.OUTSIDE_360:
					this._birdsEyeViewRef.current.setVisible(false);
					this._sitePlan360Ref.current.setVisible(true);
					this._sitePlan3DRef.current.setVisible(false);
					this._configuratorRef.current.setVisible(false);
					this._localAreaRef?.current?.setVisible(false);
					this._specificationRef?.current?.setVisible(false);
				break;
				case SitePlanVisibleType.CONFIGURATOR:
					this._birdsEyeViewRef.current.setVisible(false);
					this._sitePlan360Ref.current.setVisible(false);
					this._sitePlan3DRef.current.setVisible(false);
					this._configuratorRef.current.setVisible(true);
					this._localAreaRef?.current?.setVisible(false);
					this._specificationRef?.current?.setVisible(false);
					break;
				case SitePlanVisibleType.LOCAL_AREA:
					this._birdsEyeViewRef.current.setVisible(false);
					this._sitePlan360Ref.current.setVisible(false);
					this._sitePlan3DRef.current.setVisible(false);
					this._configuratorRef.current.setVisible(false);
					this._localAreaRef?.current?.setVisible(true);
					this._specificationRef?.current?.setVisible(false);
					break;
				case SitePlanVisibleType.THREE_D:
					this._birdsEyeViewRef.current.setVisible(false);
					this._sitePlan360Ref.current.setVisible(false);
					this._sitePlan3DRef.current.setVisible(true);
					this._configuratorRef.current.setVisible(false);
					this._localAreaRef?.current?.setVisible(false);
					this._specificationRef?.current?.setVisible(false);
				break;
				case SitePlanVisibleType.SPECIFICATION:
					this._birdsEyeViewRef.current.setVisible(false);
					this._sitePlan360Ref.current.setVisible(false);
					this._sitePlan3DRef.current.setVisible(false);
					this._configuratorRef.current.setVisible(false);
					this._localAreaRef?.current?.setVisible(false);
					this._specificationRef?.current?.setVisible(true);
				break;
			}
			this._currentSitePlanVisibleType = sitePlanVisibleType;
			if((this._previousSitePlanVisibleType!==this._currentSitePlanVisibleType)
				&&(!(this._getConfiguration().plotMenuHasCloseButton&&(sitePlanVisibleType==SitePlanVisibleType.CONFIGURATOR)))){
				PlotMenu.instance.hide();
			}
			document.body.classList.add(SitePlanVisibleType.getCssClassName(this._currentSitePlanVisibleType));
			this.setState({sitePlanVisibleType:sitePlanVisibleType});
		});
	}
	_getDimensions(){
		const element = this._elementRef.current;
		if(!element)return null;
		return [element.offsetWidth, element.offsetHeight];
	}
	_hasSpaceToShowMenuOnOpen(){
		const dimensions = this._getDimensions();
		if(!dimensions)return false;
		return (dimensions[0]>800)&&(dimensions[1]>400);
	}
	_handleShowMainMenu(){
		//if(!this._getConfiguration().goStraightToFiltersMenu){
		//	this._mainMenuRef.current.show();
		//	return;
		//}
		this._filtersRef.current.show();
		
	}
	_filterAndLoadPlots(){
		return new Promise((resolve, reject)=>{
			setTimeout(()=>{
				const filteredPlots = this._getFilteredPlots();
				const filteredUnits = this._siteJson.units.getArray().filter(unit=>{
					const unitPlotsArray = unit.plots;
					for(var i=0; i<unitPlotsArray.length; i++){
						const unitPlot = unitPlotsArray[i];
						if(filteredPlots.indexOf(unitPlot)>=0)
							return true;
					}
					return false;
				});
				this._plotsSelectionMenu?.setFilteredPlots(filteredPlots);
				this._plotMenuRef.current.setFilteredPlots(filteredPlots);
				this._birdsEyeViewRef.current.load({siteJson:this._siteJson, unitsArray:filteredUnits,
				showPlotMarkers:this._showPlotMarkers||this._doneFirstShowPlotMarkers||(this._showPlotMarkers= this._plotFilterer.filtersApplied), filtered:true})
				.then(resolve).catch(reject);
			}, 0);
		});
	}
	_getFilteredPlots(){
		return this._plotFilterer.filterPlots(this._siteJson.units.getPlotsArray())
					.filter(plot=>!plot.affordable);
	}
	_loadIndividualPlot(plot){
		setTimeout(()=>{
			this._birdsEyeViewRef.current.load({siteJson:this._siteJson,  unitsArray:[plot.unit], filtered:true});
		},0	);
	}
	_filtersChanged(){
		return new Promise((resolve, reject)=>{
			this._plotSearchRef.current.clear();
			this.setState({fadeInPlotMarkers:false});
			this._filterAndLoadPlots().then(()=>{
				resolve();
			}).catch(reject);
		});
	}
	componentDidMount(){
		this._callbackDidMount(this);
		this._plotFilterer.addPlotFilter(this._availablePricesFilterRef.current);
		this._plotFilterer.addPlotFilter(this._statusFilterRef.current);
		this._plotFilterer.addPlotFilter(this._bedroomsFilterRef.current);
		this._plotFilterer.addPlotFilter(this._houseTypeFilterRef.current);
		this._plotFilterer.addPlotFilter(this._plotSearchRef.current);
		if(this._featuresFilterRef.current)
			this._plotFilterer.addPlotFilter(this._featuresFilterRef.current);
		this._menuBarRef.current.addEventListener('isHorizontalChanged', this._menuBarIsHorizontalChanged);
		const element = this._elementRef.current;
		const configuration = this._getConfiguration();
		if(configuration.brochuresMenuEnabled){
			this._brochuresMenu = new BrochuresMenu({menuManager:this._menuManagerRef.current,
				getHandlesActivateButton:this._menuBarRef.current.getHandlesActivateButton});
			element.appendChild(this._brochuresMenu.element);
		}
		this._videoPlayerFullScreen= new VideoPlayer({
			maximized:true,
			closeable:true
		});
		element.appendChild(this._videoPlayerFullScreen.element);
		if(configuration.plotSelectionMenuEnabled){
			this._plotsSelectionMenu= new PlotsSelectionMenu({
				showPlotDetailedInformation:(siteJsonUnitPlot)=>this._plotDetailedInformationsManager.show(siteJsonUnitPlot),
				showPlotMenuForPlot:this._showPlotMenuForPlot,
				showMenu:this._handleShowMainMenu,
				clearFilters:this._clearFilters,
				showStreetView:this._handleShowStreetView,
				getSitePlanVisibleType:()=>this._currentSitePlanVisibleType,
				getConfiguration:this._getConfiguration,
				clickShowForSale:this._showForSale,
				iMenuManager:this._menuManagerRef.current
			});
			element.appendChild(this._plotsSelectionMenu.element);
		}
		if(configuration.houseTypesViewerEnabled&&!UrlParameters.salesforce){
			this._houseTypesViewer= new HouseTypesViewer({
				showMenu:this._handleShowMainMenu,
				clearFilters:this._clearFilters,
				iHouseTypesFilter:this._houseTypeFilterRef.current.iHouseTypesFilter,
				showImagesFullScreen:this._showImagesFullScreen,
				showStreetView:this._handleShowStreetView,
				addFavourite:this._handleAddFavourite, 
				removeFavourite:this._handleRemoveFavourite,
				enterHouse:this._handleEnterHouse,
				configuration
			});
			element.appendChild(this._houseTypesViewer.element);
		}
		if(UrlParameters.salesforce){
			this._houseGridSelector= new HouseGridSelector({
				showMenu:this._handleShowMainMenu,
				clearFilters:this._clearFilters,
				iHouseTypesFilter:this._houseTypeFilterRef.current.iHouseTypesFilter,
				showImagesFullScreen:this._showImagesFullScreen,
				showStreetView:this._handleShowStreetView,
				addFavourite:this._handleAddFavourite, 
				removeFavourite:this._handleRemoveFavourite,
				enterHouse:this._handleEnterHouse,
				configuration,
				showBrochureGenerationDialog:this._handleShowBrochureGenerationDialog
			});
			element.appendChild(this._houseGridSelector.element);
		}
		this._plotDetailedInformationsManager = new PlotDetailedInformationsManager({
			parentElement:this._elementRef.current, 
			addFavourite:this._handleAddFavourite, removeFavourite:this._handleRemoveFavourite,
			showStreetView:this._handleShowStreetView, showImagesFullScreen:this._showImagesFullScreen,
			showPlotsMenu:this._plotsSelectionMenu?this._plotsSelectionMenu.show:()=>{},
			configuration,
			showBrochureGenerationDialog:this._handleShowBrochureGenerationDialog,
			enterHouse:this._handleEnterHouse
		});
		this._fullScreenImageViewer = new FullScreenImagesViewer({configuration});
		element.appendChild(this._fullScreenImageViewer.element);
		PlotComparisonManager.initialize({plotDetailedInformationsManager:
			this._plotDetailedInformationsManager, sitePlanElement:this._elementRef.current});
		this._nearbySites = new NearbySites({});
		element.appendChild(this._nearbySites.element);
	}
	_menuBarIsHorizontalChanged(e){
		const isHorizontal = e.isHorizontal;
		this.setState({menuBarHorizontal:isHorizontal});
	}
	_clearFilters(){
		this._plotFilterer.clearFilters();
		this._filterAndLoadPlots();
		this._plotSearchRef.current.clear();
	}
	_showForSale(){
		this._statusFilterRef.current.setForSale();
	}
	_plotSearchSelectedPlot(plot){
		if(plot===null)
			this._filterAndLoadPlots();
		else
			this._loadIndividualPlot(plot);
	}
	_handleShowPlotMoreInformation(plot, plotMoreInformationType){
		if(this._emGalleryFullScreenImagesViewer&&plotMoreInformationType===PlotMoreInformationType.GALLERY)
		{
			this._emGalleryFullScreenImagesViewer.show({src:plot.houseType?.galleryUrl});
			return;
		}
		const plotMoreInformation = this._plotMoreInformationRef.current;
		plotMoreInformation.show(this._siteJson, plot, undefined, plotMoreInformationType);
	}
	_handleZoomChange(value){
		this._birdsEyeViewRef.current.setZoom(value);
	}
	_setMenuBarZoom(value){
		this._menuBarRef.current.setZoom(value);
	}
	_handleSetFavouritesActive(active){
		if(active)this._favouritesRef.current.show();
		else this._favouritesRef.current.hide();
	}
	_handleFavouritesHide(){
		this._menuBarRef.current.setFavouritesActive(false);
	}
	_handleExpandImage(params){
		this._imageViewerRef.current.load(params);
	}
	_handleRemoveFavourite(plot){
		this._favouritesRef.current.remove(plot.hash);
		plot.selected=false;
	}
	_handleAddFavourite(plot){
		const favourites = this._favouritesRef.current;
		if(favourites.count>=SitePlan._MAX_FAVOURITES){
			this._showTooManyFavouritesDialog();
			return false;
		}
		plot.selected=true;
		this._favouritesRef.current.add(new Favourite({payload:plot, description:`<span class="number">Plot ${plot.number}</span>&nbsp;${plot.name}`, 
		imageUrl:`${Urls.getAssetsForSite(this._getConfiguration().siteSlug)}${UrlHelper.removeStartSlash(plot.frontViewImage.getBestEntryToFitHeight(50).relativePath)}`, hash:plot.hash,
			sortValue:plot.number,
			onRemove:()=>{
				plot.selected=false;
				GoogleAnalytics.logEvent('removedPlotFromFavourites', {plotNumber:plot.number});
			},
			onClick:()=>{this._handleClickedFavourite(plot)}
		}));
		GoogleAnalytics.logEvent('addedPlotToFavourites', {plotNumber:plot.number});
		return true;
	}
	_handleClickedFavourite(plot){
		if(this._getConfiguration().plotMoreInformationHasOverview){
			this._handleShowPlotMoreInformation(plot, PlotMoreInformationType.OVERVIEW);
			return;
		}
			switch(this._currentSitePlanVisibleType){
				case SitePlanVisibleType.OUTSIDE_360:
					this._handleShowStreetView({nearPlot:plot});
					return;
				default:
					this._showPlotMenuForPlot(plot);
					return;
			}
	}
	_handleBackFromSitePlan360(){
		this._setVisibleType(SitePlanVisibleType.BIRDS_EYE_VIEW);
	}
	_handleEnterHouse(plot){
		this._filtersRef.current.hide();
		this._handleEnterHouseByPlotNumber(plot.number);
	}
	_handleEnterHouseByPlotNumber(plotNumber){
		this._setVisibleType(SitePlanVisibleType.CONFIGURATOR);
		if(!this._siteJson)return;
		const plot = this._siteJson.getPlotByNumber(plotNumber);
		GoogleAnalytics.logEvent('enteredPlot', {plotNumber});
		this._configuratorRef.current.showConfiguratorForPlot({roomName:null, plot:plot});
	}
	_handleShowLocalArea(){
		this._filtersRef.current?.hide();
		this._setVisibleType(SitePlanVisibleType.LOCAL_AREA);
		GoogleAnalytics.logEvent('localArea', {});
		//this._localAreaRef.current.show();
	}
	_handleShowSpecification(){
		this._filtersRef.current?.hide();
		this._setVisibleType(SitePlanVisibleType.SPECIFICATION);
		
	}
	_handleHideLocalArea(){
		this._setVisibleType(SitePlanVisibleType.BIRDS_EYE_VIEW, true);
	}
	_handleHideSpecification(){
		this._setVisibleType(SitePlanVisibleType.BIRDS_EYE_VIEW, true);
	}
	_handlePreviousSitePlanVisibleTypeElseDefault(){
		if(this._previousSitePlanVisibleType)
			this._setVisibleType(this._previousSitePlanVisibleType);
		else {
			this._setVisibleType(SitePlanVisibleType.BIRDS_EYE_VIEW);
		}
	}
	_handleShowOutside360(params){
		Tutorials.haveBeenToOutside360=true;
		this._filtersRef.current.hide();
		let outside360UniqueId = params?.outside360UniqueId;
		const cameraDirectionEulerAngles = params?.cameraDirectionEulerAngles;
		if(outside360UniqueId ===undefined||outside360UniqueId===null)
			outside360UniqueId=0;
		this._sitePlan360Ref.current.switchToOutside360(outside360UniqueId, cameraDirectionEulerAngles).then(()=>{
		}).catch(console.error);
		setTimeout(()=>{
			this._setVisibleType(SitePlanVisibleType.OUTSIDE_360);
		},0);
	}
	_handleShow3d(){
		this._filtersRef.current.hide();
		this._setVisibleType(SitePlanVisibleType.THREE_D);
		this._load3dSite().then(()=>{
			
		}).catch(console.error);
	}
	_handleShowDefaultOutside360(){
		Tutorials.haveBeenToOutside360=true;
		const configuration = this._getConfiguration();
		const defaultOutside360PlotNumber = configuration.defaultOutside360PlotNumber
			?configuration.defaultOutside360PlotNumber:18;
		let nearestOutside360Move = this._siteJson?.units?.getPlotByNumber(defaultOutside360PlotNumber)?.unit?.nearestOutside360Move;
		if(!nearestOutside360Move)
			nearestOutside360Move = this._siteJson?.units?.getFirstPlot()?.unit.nearestOutside360Move;
		if(!nearestOutside360Move)return;
		this._handleShowOutside360({outside360UniqueId:nearestOutside360Move.outside360UniqueId, 
			cameraDirectionEulerAngles:nearestOutside360Move.cameraAngleToFaceFrontDoor});
		GoogleAnalytics.logEvent('viewedDefaultOutside360', {});
	}
	_showTooManyFavouritesDialog(){
		Dialog.create({
			title:'Too many favourites!',
			className:'brochure-generation-result-dialog error',
			message:'You may only add up to ten plots. Remove another plot first!',
			options:[{text:'OK'}]
		});
	}
	_handleShowBrochureGenerationDialog(params){
		const plot = params.plot;
		this._brochureGenerationRef.current.load({plots:plot?[plot]:null});
	}
	_handleShowSendFavouritesBrochure(){
		this._brochureGenerationRef.current.load({});
	}
	_handleShowStreetView(e){
		const nearestOutside360Move = e.nearPlot?.unit.nearestOutside360Move;
		if(!nearestOutside360Move)return;
		GoogleAnalytics.logEvent('wentToPlotOutside360', {plotNumber:e.nearPlot.number});
		this._handleShowOutside360({outside360UniqueId:nearestOutside360Move.outside360UniqueId, 
			cameraDirectionEulerAngles:nearestOutside360Move.cameraAngleToFaceFrontDoor});
	}
	_handleShowBrochures(){
		this._brochuresMenu?.show();
	}
	_handleShowPlots(){
		this._plotsSelectionMenu?.show({});
	}
	_handleShowHouseTypes(){
		this._houseTypesViewer?.show({});
	}
	_handleShowHouseGridSelector(){
		this._filtersRef.current?.hide();
		this._houseGridSelector?.show();
	}
	_handleShowSuggestedSites(){
		this._nearbySites.show();
	}
	_initializeConfiguredCssClasses(plotStatusConfigurations){
		if(this._initializedConfiguredCssClasses)return;
		const cssHtmlString = plotStatusConfigurations.toCssHtmlString();
		StylesHelper.appendCssToPage(cssHtmlString);
		this._initializedConfiguredCssClasses=true;
	}
	_hidePlotMenu(){
		this._plotMenuRef.current?.hide();
	}
	_showPlotMenuForPlot(plot, zoomOut, c){
		const showPlotMenu = ()=>{
			let markerPosition;
			switch(this._currentSitePlanVisibleType){
				case SitePlanVisibleType.BIRDS_EYE_VIEW:
					markerPosition = this._birdsEyeViewRef.current?.getMarkerPositionForPlotNumber(plot.number);
					break;
				case SitePlanVisibleType.OUTSIDE_360:
					markerPosition = c?c:[0,0];
					break;
				default:
					this._showPlotDetailedInformation(plot);
					return;
			}
			this._plotMenuRef.current.show({position:markerPosition,
				siteJson:this._siteJson, plot:this._siteJson.units.getPlotByNumber(plot.number), 
				untilClickOff:true}).catch(console.error);
		};
		if(zoomOut){
			this._birdsEyeViewRef.current?.setZoom(1).then(()=>{
				showPlotMenu();
			}).catch(console.error);
		}
		else showPlotMenu();
	}
	_showPlotDetailedInformation(siteJsonUnitPlot){
		this._plotDetailedInformationsManager.show(siteJsonUnitPlot);
	}
	_showImagesFullScreen(images, src){
		if(this._emGalleryFullScreenImagesViewer&&src){
			this._emGalleryFullScreenImagesViewer.show({src});
			return;
		}
		this._fullScreenImageViewer.show({images});
	}
	_handlePlaySiteVideo(){
		this._videoPlayerFullScreen.play({url:Urls.videos+'site.mp4'});
	}
	_handleShowTwoDSitePlan(){
		this._fullScreenImageViewer.show({images:['twoDSitePlan.jpg']});
	}
	_showPrivacyPolicy(){
		this._privacyPolicyRef.current.show();
	}
	render() {
	    if(this._getConfiguration().isIX2D)
			document.body.classList.add('is-ix2d');
		const classNameSitePlan = "site-plan "+(window.isMobile?'mobile ':'')+SitePlanVisibleType.getCssClassName(this.state.sitePlanVisibleType) 
		+(this.state.menuBarHorizontal?' menu-bar-horizontal':'')
		+(this.state.fadeInPlotMarkers?' fade-in-unit-markers':'')
		+(this._getConfiguration().threeDEnabled?'':' disable-3d')
		+((!this._getConfiguration().hideBrochuresIconTillCustomerGeneratesBrochure)?'':' hide-brochures-icon-till-customer-generates-brochure');
		const brochureGeneration = SiteSpecific.BrochureGeneration?
			(<SiteSpecific.BrochureGeneration ref={this._brochureGenerationRef} 
				getSiteAndUnits={()=>[this._siteJson, this._siteJson.units]}
					getSelectedFavourites={()=>this._favouritesRef.current.selectedFavourites.map(favourite=>favourite.payload)}
				showBrochuresMenu={()=>{
					this._brochuresMenu?.show({scrollToBottom:true});
					}}
				getConfiguration={this._getConfiguration} showPrivacyPolicy={this._showPrivacyPolicy}/>)
				:
				
					(<BrochureGeneration ref={this._brochureGenerationRef} 
				getSiteAndUnits={()=>[this._siteJson, this._siteJson.units]}
					getSelectedFavourites={()=>this._favouritesRef.current.selectedFavourites.map(favourite=>favourite.payload)}
				showBrochuresMenu={()=>{this._brochuresMenu?.show({scrollToBottom:true});}}
				getConfiguration={this._getConfiguration}/>);
		const plotMenu = this._getConfiguration()?
			(<PlotMenu ref={this._plotMenuRef} showPlotMoreInformation={this._handleShowPlotMoreInformation} 
				configuration = {this._getConfiguration()}
			showBrochureGenerationDialog={this._handleShowBrochureGenerationDialog}
			showStreetView={this._handleShowStreetView} onHide={this._handlePlotMenuHide} addFavourite ={this._handleAddFavourite} 
			removeFavourite ={this._handleRemoveFavourite} enterHouse = {this._handleEnterHouse} 
			showPlotDetailedInformation={this._showPlotDetailedInformation} showImagesFullScreen={this._showImagesFullScreen}></PlotMenu>)
			:null;
			return (<div className={classNameSitePlan} ref={this._elementRef}>
			<div className="main-view">
				<Spinner ref={this._spinnerRef} spinnerHandles={this._spinnerHandles}></Spinner>
				<MouseBlocker ref={this._mouseBlockerRef} spinnerHandles={this._spinnerHandles}></MouseBlocker>
				<BirdsEyeView ref ={this._birdsEyeViewRef} 
					showPlotMoreInformation={this._handleShowPlotMoreInformation} 
					showBrochureGenerationDialog = {this._handleShowBrochureGenerationDialog} 
					updateExternalZoomSource={this._setMenuBarZoom} 
					favouritesRef={this._favouritesRef}
					getContainerAspectRatio={this._getAspectRatio} 
					zoomMin={SitePlan.BIRDS_EYE_VIEW_ZOOM_MIN} 
					zoomMax={SitePlan.BIRDS_EYE_VIEW_ZOOM_MAX}
					showOutside360={this._handleShowOutside360}
					showImage={()=>{}}
					enterHouse={this._handleEnterHouse} addFavourite ={this._handleAddFavourite}
					removeFavourite={this._handleRemoveFavourite}
					plotMenuRef={this._plotMenuRef}
					showPlotDetailedInformation={this._showPlotDetailedInformation}
					getConfiguration={this._getConfiguration}></BirdsEyeView>
				<SitePlan360 ref={this._sitePlan360Ref} configuration={this._getConfiguration()} getInsertedMenuItemsHandler={()=>this._menuBarRef.current.insertedMenuItemsHandler}
				getInsertedMenuItemsAtEndHandler={()=>this._menuBarRef.current.insertedMenuItemsAtEndHandler}
				onBack={this._handleBackFromSitePlan360} goToConfigurator={this._handleEnterHouseByPlotNumber}
				showPlotMenu={this._showPlotMenuForPlot} showPlotDetailedInformation={this._showPlotDetailedInformation}
	hidePlotMenu={this._hidePlotMenu}></SitePlan360>
				<SitePlan3D ref={this._sitePlan3DRef} hide={this._handlePreviousSitePlanVisibleTypeElseDefault}
					getInsertedMenuItemsHandler={()=>this._menuBarRef.current.insertedMenuItemsHandler}
					getInsertedMenuItemsAtEndHandler={()=>this._menuBarRef.current.insertedMenuItemsAtEndHandler}
					getConfiguration={this._getConfiguration}
				></SitePlan3D>
				<Configurator ref={this._configuratorRef} hide ={this._handlePreviousSitePlanVisibleTypeElseDefault} 
				getInsertedMenuItemsHandler={()=>this._menuBarRef.current.insertedMenuItemsHandler}
				configuration={this._getConfiguration()}/>
				<LocalArea ref={this._localAreaRef} hide ={this._handleHideLocalArea} 
				getInsertedMenuItemsHandler={()=>this._menuBarRef.current.insertedMenuItemsHandler}
				configuration={this._getConfiguration()}/>
				<Specification ref={this._specificationRef} hide ={this._handleHideSpecification} 
				getInsertedMenuItemsHandler={()=>this._menuBarRef.current.insertedMenuItemsHandler}
				configuration={this._getConfiguration()}/>
			</div>
			<MenuManager outerElementRef={this._elementRef} ref={this._menuManagerRef}>
				<MenuBar ref ={this._menuBarRef}  getConfiguration={this._getConfiguration}
					setFavouritesActive={this._handleSetFavouritesActive} 
					showMainMenu={this._handleShowMainMenu} 
					onZoomChange={this._handleZoomChange} zoomMin={SitePlan.BIRDS_EYE_VIEW_ZOOM_MIN} 
					zoomMax={SitePlan.BIRDS_EYE_VIEW_ZOOM_MAX} 
					showDefaultOutside360={this._handleShowDefaultOutside360} 
					getDragDropRecipientForStreetViewButton={()=>this._birdsEyeViewRef.current} 
					showDefault3d={this._handleShow3d} showBrochures={this._handleShowBrochures}
					showPlots={this._handleShowPlots} 
					showHouseTypes={this._handleShowHouseTypes}
					showHouseGridSelector={this._handleShowHouseGridSelector}
					playSiteVideo={this._handlePlaySiteVideo}
					showTwoDSitePlan={this._handleShowTwoDSitePlan}
					showSuggestedSites={this._handleShowSuggestedSites}
					showLocalArea={this._handleShowLocalArea}
					showSpecification={this._handleShowSpecification}></MenuBar>
				<MainMenu ref={this._mainMenuRef}></MainMenu>
				<Filters ref={this._filtersRef} getConfiguration={this._getConfiguration} clickClear={this._clearFilters} clickShowForSale={this._showForSale}></Filters>
				<AvailablePricesFilter ref = {this._availablePricesFilterRef} onSelectedOptionsChange={this._filtersChanged}></AvailablePricesFilter>
				<StatusFilter ref={this._statusFilterRef} onSelectedOptionsChange={this._filtersChanged}></StatusFilter>
				<BedroomsFilter ref={this._bedroomsFilterRef} onSelectedOptionsChange={this._filtersChanged}></BedroomsFilter>
				<HouseTypeFilter ref={this._houseTypeFilterRef} onSelectedOptionsChange={this._filtersChanged}></HouseTypeFilter>
				<FeaturesFilter ref={this._featuresFilterRef} onSelectedOptionsChange={this._filtersChanged}></FeaturesFilter>
				<PlotSearch ref={this._plotSearchRef} selectedPlot={this._plotSearchSelectedPlot} onSelectedOptionsChange={this._filtersChanged}></PlotSearch>
				<PlotMoreInformation ref={this._plotMoreInformationRef} onExpandImage={this._handleExpandImage} 
					addFavourite={this._handleAddFavourite} 
					removeFavourite={this._handleRemoveFavourite}
					showStreetView={this._handleShowOutside360}
				configuration = {this._getConfiguration()}>
				</PlotMoreInformation>
					{brochureGeneration}
				<Favourites ref={this._favouritesRef} callbackComparing={this._hidePlotMenu} 
				onHide={this._handleFavouritesHide} getConfiguration={this._getConfiguration}
				onShowSendFavouritesBrochure={this._handleShowSendFavouritesBrochure}/>
				<ImageViewer ref={this._imageViewerRef}/>
				<PrivacyPolicy ref={this._privacyPolicyRef}/>
			</MenuManager>
			{plotMenu}
		</div>)
	}
}
